import Action from '../base/action';
import {VRInfoDefaultStyle} from "shared";

class VRInformation extends Action {
    properties;
    VRInformationMode;
    styleId;
    rawText;

    DefaultStyle = VRInfoDefaultStyle;

    constructor(props) {
        super(props);
        this.rawText = props.text;
        this.properties = props;
        this.minDuration = 3000;
        this.VRInformationMode = {
            SCENE_FIX: "scene-fix",
            SCENE_FOLLOW: "scene-follow",
            CAMERA_FIX: "camera-fix",
        };
        this.styleId = props.styleId || null;
    }

    _initStyle(style = {}) {
        this.properties = {...this.DefaultStyle, ...style?.properties, ...this.properties};
    }

    async execute(eventLoop) {
        if (this.styleId) {
            this._initStyle(eventLoop.training.resources[this.styleId]);
        }

        if (!this.properties.duration && this.properties.timeLineDuration - this.properties.startTime > this.minDuration) {
            this.properties.duration = this.properties.timeLineDuration - this.properties.startTime;
        }

        this.properties.text = this.interpolateVariableValues(eventLoop.training, this.rawText);

        if (!this.properties.VRMode && !this.properties.NonVRMode) {
            VRMessageController.addMessage(this.properties);
            return;
        }

        VRInformationController.addMessage(this.properties);
    }

    async stop(timeline, runningActions = null) {
        if (runningActions && !wv.effectController.serverlessEditorLoadingState) {
            this.removePrunedMessages(runningActions, VRInformationController);
            this.removePrunedMessages(runningActions, VRMessageController);
        } else {
            VRInformationController.removeAllMessage();
            VRMessageController.removeAllMessage();
        }
    }

    removePrunedMessages(runningActions, controller) {
        for (const message of controller.getMessages()) {
            if (!this.isMessageInRunningActions(message.messageId, runningActions)) {
                controller.removeMessage(message, true);
            }
        }
    }

    isMessageInRunningActions(messageID, runningActions) {
        return runningActions.some(action => messageID === action?.properties?.messageId);
    }
}

export default VRInformation;
